import { useSnackbar } from "notistack";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Item, ItemModal, MallHead } from "../components/mall";
import { useEffect, useState } from "react";
import { GetProfile, goodListApi, userPointsApi } from "../utils/api";
import { useTranslation } from "next-i18next";
import { ItemSkeleton } from "@/components/mall/item-skeleton";

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "mall"])),
    },
  };
}

const Mall = () => {
  const { t: commonT } = useTranslation("common");
  const { enqueueSnackbar } = useSnackbar();
  const [currentItem, setCurrentItem] = useState();
  const [cupPointsInfo, setCupPointsInfo] = useState<{
    compensations;
    total;
  }>();
  const { data, mutate: fetchProfile } = GetProfile();
  const profileData = data?.data;

  console.log("profile", { profile: profileData });

  const [goodList, setGoodList] = useState<any[]>();

  const isLoggedIn = !!profileData?.profile?.name;

  const fetchGoodList = async () => {
    const res = await goodListApi();
    console.log("goodList", res);

    if (res.err) {
      return;
    }

    setGoodList(res.data.goods || []);
  };

  const fetchPoints = async () => {
    const res = await userPointsApi();
    console.log("userPointsApi", { res });
    setCupPointsInfo(res?.data);
  };

  const init = () => {
    fetchGoodList();
    fetchProfile();
    fetchPoints();
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <style>{`body { background-color: black; }`}</style>
      <div className="pt-[110px] px-[80px] font-light mb-[226px] text-white">
        <div className="max-w-[1440px] mx-auto relative pt-[80px]">
          <MallHead
            isLoggedIn={isLoggedIn}
            canClaimPoints={cupPointsInfo?.compensations?.length > 0}
            points={cupPointsInfo?.total}
            myPointsClickEvent="mall_my_cup_points_click"
          />

          <div className="mt-[90px] flex flex-wrap">
            {Array.isArray(goodList)
              ? goodList.map((good, index) => {
                  return (
                    <Item
                      key={good.goodsId}
                      item={good}
                      index={index}
                      onItemClick={(item) => {
                        if (!isLoggedIn) {
                          enqueueSnackbar(commonT("connect_wallet_first"), {
                            variant: "info",
                          });
                          return;
                        }

                        setCurrentItem(item);
                      }}
                    />
                  );
                })
              : Array(3)
                  .fill("")
                  .map((_, i) => <ItemSkeleton key={i} index={i} />)}
          </div>

          <div className="mt-[80px] text-center text-[24px] font-normal opacity-50">
            More Coming Soon ...
          </div>
        </div>
      </div>

      {currentItem && (
        <ItemModal
          item={currentItem}
          isHolder={!!profileData?.Holder}
          cupPointsInfo={cupPointsInfo}
          onClose={() => {
            setCurrentItem(null);
            init();
          }}
        />
      )}
    </>
  );
};

export default Mall;
